import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'comparison';
let loaded = loadState(STORE_KEY) || {};

const state = {
	selectedComparisonProducts: loaded.selectedComparisonProducts || [],
};

const mutations = {
	ADD_COMPARISON_PRODUCT(state, product) {
		state.selectedComparisonProducts.push(product);
		saveState(STORE_KEY, state);
	},
	REMOVE_COMPARISON_PRODUCT(state, productId) {
		state.selectedComparisonProducts =
			state.selectedComparisonProducts.filter((p) => p.id !== productId);
		saveState(STORE_KEY, state);
	},
	CLEAR_COMPARISON_PRODUCTS(state) {
		state.selectedComparisonProducts = [];
		saveState(STORE_KEY, state);
	},
};

const actions = {
	addComparisonProduct({ commit }, product) {
		commit('ADD_COMPARISON_PRODUCT', product);
	},
	removeComparisonProduct({ commit }, productId) {
		commit('REMOVE_COMPARISON_PRODUCT', productId);
	},
	clearComparisonProducts({ commit }) {
		commit('CLEAR_COMPARISON_PRODUCTS');
	},
};

const getters = {
	selectedComparisonProducts: (state) => state.selectedComparisonProducts,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
